export default __webpack_public_path__ + "static/dumbbell-dbe47d7f5779a8a9649671d85c8196bc.png";